/**
 * @desc 确认任务
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inventoryMaster.confirm.Params, options?: any) {
  return updateResponse(
    http(URL + `/inventoryMaster/confirm`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
